import React from 'react'
import { t } from 'ttag'

import { Modal } from 'components/shared/Modal/Modal'

import styles from './DeleteInterviewEvaluatorModal.module.scss'

export const DeleteInterviewEvaluatorModal = ({
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => (
  <Modal
    className={styles.modal}
    cancelLabel={t`Cancel`}
    confirmLabel={t`Yes, remove`}
    title={t`Remove evaluator`}
    {...{ onCancel, onClose, onConfirm, isOpen }}
  >
    <Modal.Header />
    <Modal.Content className={styles.content}>
      <p className={styles.text}>
        {t`Are you sure you want to remove this evaluator?`}
      </p>
    </Modal.Content>
    <Modal.Footer />
  </Modal>
)
